import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  NgSelectComponent,
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
} from '@ng-select/ng-select';
import { AccordionComponent } from '../../../../../shared/components/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../shared/components/accordion/accordion-item.component';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';
import { LoadingComponent } from '../../../../../shared/components/loading/loading.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import {
  InventoryService,
  FranchiseResultModel,
  VtexInventoryByFranchiseResponse,
} from '../../../../../core/services/inventory/inventory.service';
import { customFranchiseSearchFn } from '../../../../../core/helpers/franchise-search.helper';

@Component({
  selector: 'app-sku-inventory',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    AccordionComponent,
    AccordionItemComponent,
    AlertComponent,
    LoadingComponent,
    ButtonComponent,
  ],
  templateUrl: './sku-inventory.component.html',
})
export class SkuInventoryComponent {
  @Input({ required: true }) skuId!: number;
  @Input({ required: true }) franchises!: FranchiseResultModel[];
  @Input() loadingAccounts = false;

  selectedAccounts: string[] | string = [];
  loading = false;
  error: string | null = null;
  result: VtexInventoryByFranchiseResponse[] = [];
  hasSearched = false;

  customSearchFn = customFranchiseSearchFn;

  constructor(private readonly inventory: InventoryService) {}

  search(): void {
    this.error = null;
    this.loading = true;

    let accounts: string[];
    if (this.selectedAccounts instanceof Array) {
      accounts = this.selectedAccounts;
    } else {
      accounts = [this.selectedAccounts];
    }

    accounts = accounts.filter(a => a !== 'ALL');
    const req = { skuId: this.skuId, accounts } as any;

    this.inventory.getInventory(req).subscribe({
      next: res => {
        this.result = res || [];
        this.hasSearched = true;
        this.loading = false;
      },
      error: err => {
        console.error(err);
        if (err?.status === 404) {
          this.error = 'Nenhum inventário encontrado.';
        } else {
          this.error = 'Falha ao buscar inventário.';
        }
        this.loading = false;
      },
    });
  }

  getAvailableTotal(r: VtexInventoryByFranchiseResponse): number {
    if (!r?.items?.length) return 0;
    return r.items.reduce((acc, it) => {
      const available = (it.totalQuantity || 0) - (it.reservedQuantity || 0);
      return acc + (available > 0 ? available : 0);
    }, 0);
  }

  get sortedResults(): VtexInventoryByFranchiseResponse[] {
    return [...this.result].sort(
      (a, b) => this.getAvailableTotal(b) - this.getAvailableTotal(a)
    );
  }
}
